export const SERVICE_DESK_PRODUCT = 'servicedesk';
export const getJsmProjectSettingsUrl = (projectKey?: string) =>
	`/jira/${SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
export const jsmProjectSettingsUrl = getJsmProjectSettingsUrl();
